import { LoadableAfterPaint } from '@confluence/loadable';

export { ANALYTICS_SOURCE } from '../src/BulkAccessManagementPage';

export const BulkAccessManagementPage = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkAccessManagementPage" */ '../src/BulkAccessManagementPage'
			)
		).BulkAccessManagementPage,
	name: 'BulkAccessManagementPage',
});
